import Dexie from "dexie";
import { Book } from "../models/Book.ts";
import { version } from "../../package.json";
import Bedok from "../models/Bedok.json";

const bedok: any = Bedok;

export class Books extends Dexie {
    private books: Dexie.Table<Book, number>;

    private readonly language = "khmer";

    constructor() {
        super("Books");
        this.version(parseInt(version))
            .stores({
                books: "++id, book, language"
            })
            .upgrade((tx) => {
                // TODO: later delete old version of dexie
                // return tx
                //     .table("books")
                //     .toCollection()
                //     .modify((book) => {});
            });
        this.books = this.table("books");
    }

    async get(book: number): Promise<string | null> {
        const item = await this.books.where("book").equals(book).first();
        return item ? item.language : null;
    }

    async update(book: number, language: string): Promise<number> {
        const item = await this.books.where("book").equals(book).first();

        if (item) {
            item.language = language;
            return this.books.update(item.id!, item);
        } else {
            return this.books.add({ book, language });
        }
    }

    async remove(book: number) {
        const item = await this.books.where("book").equals(book).first();
        return this.books.delete(item!.id!);
    }

    ///

    getBasket(book: number): number {
        for (
            let index = 0;
            index < bedok[this.language].baskets.length;
            index++
        ) {
            const basket = bedok[this.language].baskets[index];
            if (book <= basket + 1) return index;
        }
        return -1; // Return a default value if no basket is found
    }
}
